import { useCoachMark } from '#hooks/useCoachMark';

interface CoachMarkTooltipProps {
  message: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  oneLine?: boolean;
  // WeeklyCalenderDetail 컴포넌트를 참고
  tooltipStyle?: React.CSSProperties;
  tooltipArrowStyle?: React.CSSProperties;
}

const CoachMarkTooltip = ({
  message,
  position = 'top',
  oneLine = false,
  tooltipStyle = {},
  tooltipArrowStyle = {}
}: CoachMarkTooltipProps) => {
  const TOOLTIP_ARROW_HEIGHT = 8; // 8px arrow height
  const TOOLTIP_OFFSET = 8 + TOOLTIP_ARROW_HEIGHT; // 8px from parent element

  const getPositionStyle = (currentPosition: typeof position) => {
    switch (currentPosition) {
      case 'top':
        return {
          bottom: `calc(100% + ${TOOLTIP_OFFSET}px)`,
          left: '50%',
          transform: 'translateX(-50%)'
        };
      case 'bottom':
        return {
          top: `calc(100% + ${TOOLTIP_OFFSET}px)`,
          left: '50%',
          transform: 'translateX(-50%)'
        };
      case 'left':
        return {
          right: `calc(100% + ${TOOLTIP_OFFSET}px)`,
          top: '50%',
          transform: 'translateY(-50%)'
        };
      case 'right':
        return {
          left: `calc(100% + ${TOOLTIP_OFFSET}px)`,
          top: '50%',
          transform: 'translateY(-50%)'
        };
      default:
        return {}; // Default to empty style
    }
  };

  const getArrowStyle = (
    currentPosition: typeof position
  ): React.CSSProperties => {
    switch (currentPosition) {
      case 'top':
        return {
          top: `100%`,
          left: '50%',
          transform: 'translateX(-50%) rotate(180deg)'
        };
      case 'bottom':
        return {
          bottom: `100%`,
          left: '50%',
          transform: 'translateX(-50%) rotate(0deg)'
        };
      case 'left':
        return {
          left: `100%`,
          top: '50%',
          transform: 'translateY(-50%) rotate(90deg)'
        };
      case 'right':
        return {
          right: `100%`,
          top: '50%',
          transform: 'translateY(-50%) rotate(-90deg)'
        };
      default:
        return {}; // Default to empty style
    }
  };

  const { isCoachMark } = useCoachMark();

  const arrowRotate = getArrowStyle(position).transform?.split(' ')[1];

  const arrowStyle = {
    ...tooltipArrowStyle,
    transform: `${tooltipArrowStyle.transform || ''} ${arrowRotate}`
  };

  if (!isCoachMark) return null;

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 1000,
        ...getPositionStyle(position),
        ...tooltipStyle
      }}
    >
      <div className="flex-col justify-start items-end flex">
        <div className="pr-10 flex-col justify-start items-start gap-10 flex" />
        <div
          className="self-stretch px-12 py-8 bg-[#7750e9] rounded-xl justify-center items-center gap-10 inline-flex"
          style={{ whiteSpace: oneLine ? 'nowrap' : 'pre' }}
        >
          <div className="text-center text-[#f7f5ff] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            {message}
          </div>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="8"
        viewBox="0 0 21 8"
        fill="none"
        style={{
          ...getArrowStyle(position),
          position: 'absolute',
          ...arrowStyle
        }}
      >
        <path
          d="M9.8753 0.499756C10.2405 0.207581 10.7595 0.207581 11.1247 0.499756L20.5 8L0.5 8L9.8753 0.499756Z"
          fill="#7750E9"
        />
      </svg>
    </div>
  );
};

export default CoachMarkTooltip;
